<template>
  <Modal class="choose-from-server-modal">
    <button
      type="button"
      class="btn-close"
      @click.stop="setActiveModal(null)">
      <i class="fas fa-times"></i>
    </button>
    <div class="choose-from-server-container">
      <h5>
        <button
          @click.stop="setActiveModal('SelectSourceModal')">
          <i class="fas fa-chevron-left"></i>
        </button>
        รายการไฟล์ในระบบ
      </h5>
      <div v-if="hasFileOnServer">
        <div class="search-container">
          <input
            class="form-control form-control-search"
            placeholder="ค้นหาด้วยชื่อไฟล์"
            v-model="searchTerm"
            @change.stop="onSearchFile" />
          <EmptyMessage v-if="searchNotFound">
            <h3>ไม่พบไฟล์ที่ค้นหา</h3>
            <button
              type="button"
              class="btn btn-light btn-md mt-4"
              @click="clearSearch">
              ล้างผลการค้นหา
            </button>
          </EmptyMessage>
        </div>
        <div
          class="file-browser-container file-browser-selected-files"
          v-if="selectedFiles.length">
          <h5>รายการไฟล์ที่เลือก</h5>
          <div
            v-for="(file, index) in selectedFiles"
            :key="index"
            class="file-info checked"
            @click="onSelectFileOnServer(file, null)">
            <div class="circle-selector">
              <i class="far fa-circle uncheck"></i>
              <i class="fas fa-check-circle check"></i>
            </div>
            <div class="info--icon">
              <i :class="getFileIconClass(file.type)"></i>
            </div>
            <div class="info--meta">
              <h6>{{file.name}}.{{file.type}}</h6>
              <p>อัปโหลดเมื่อ: {{ formatDateTime(file.createdAt) }}</p>
            </div>
          </div>
        </div>
        <div
          class="file-browser-container"
          v-for="(value, key) in allBrowsedFiles"
          :key="key">
          <!-- DON'T USE === -->
          <div v-if="key == page">
            <div
              class="file-info"
              v-for="(file, index) in value"
              :key="index"
              @click="onSelectFileOnServer(file, key)">
              <div class="circle-selector">
                <i class="far fa-circle uncheck"></i>
                <i class="fas fa-check-circle check"></i>
              </div>
              <div class="info--icon">
                <i :class="getFileIconClass(file.type)"></i>
              </div>
              <div class="info--meta">
                <h6>{{file.name}}.{{file.type}}</h6>
                <p>อัปโหลดเมื่อ: {{ formatDateTime(file.createdAt) }}</p>
              </div>
            </div>
          </div>
        </div>
        <div
          :class="{'no-nav': !isShowPagination()}"
          class="file-browser-bottom">
          <div
            class="pagination-container"
            v-if="isShowPagination()">
            <ul class="pagination text-center">
              <button
                class="page-link page-first link"
                @click="loadPage(1)"
                :disabled="page === 1">
                <i class="fas fa-angle-double-left"></i>
              </button>
              <button
                class="page-link page-previous link"
                @click="loadPage(previousPage)"
                :disabled="page === 1">
                <i class="fas fa-angle-left"></i>
              </button>
              <div v-for="n in serverFiles.lastPage" :key="n">
                <button
                  :class="{ active: isActivePage(n) }"
                  class="page-link link"
                  @click="loadPage(n)"
                  v-if="showPaginate(n)">
                  {{ n }}
                </button>
              </div>
              <button
                class="page-link page-next link"
                @click="loadPage(nextPage)"
                v-if="page < serverFiles.lastPage || !page"
                :disabled="page === serverFiles.lastPage">
                <i class="fas fa-angle-right"></i>
              </button>
              <button
                class="page-link page-last link"
                v-if="page < (serverFiles.lastPage - 1) || !page"
                @click="loadPage(serverFiles.lastPage)">
                <i class="fas fa-angle-double-right"></i>
              </button>
            </ul>
          </div>
          <div>
            <button
              type="button"
              class="btn btn-primary"
              :disabled="selectedFiles.length === 0"
              @click="attachSelectedFilesFromServer">
              แนบไฟล์ที่เลือก
            </button>
          </div>
        </div>
      </div>
      <EmptyMessage
        class="empty-small"
        v-if="!hasFileOnServer">
        <h5>ไม่มีไฟล์ในระบบ</h5>
        <button
          class="btn btn-light btn-md mt-4"
          @click.stop="$refs.file.click()">
          อัปโหลดไฟล์
        </button>
      </EmptyMessage>
    </div>
  </Modal>
</template>

<script>
import _ from 'lodash';
import { mapActions, mapGetters } from 'vuex';
import dateFormatter from '@/utils/dateFormatter';
import EmptyMessage from '@/components/EmptyMessage.vue';
import Modal from '@/components/Modal.vue';

import attachmentMixin from './attachmentMixin';

export default {
  mixins: [attachmentMixin, dateFormatter],
  data() {
    return {
      allBrowsedFiles: {},
      selectedFiles: [],
      searchTerm: null,
    };
  },
  computed: {
    ...mapGetters([
      'attachment',
      'attachmentID',
      'serverFiles',
      'page',
      'searchNotFound',
      'hasFileOnServer',
    ]),
    limitPage() {
      if (this.page) {
        return parseInt(this.page, 10) + 4;
      }
      return 4;
    },
    nextPage() {
      return parseInt(this.page, 10) + 1;
    },
    previousPage() {
      return parseInt(this.page, 10) - 1;
    },
  },
  components: {
    EmptyMessage,
    Modal,
  },
  created() {
    this.loadPage(1);
  },
  methods: {
    ...mapActions([
      'setActiveModal',
      'setAttachmentID',
      'loadAllFilesFromServer',
      'searchFile',
      'setPage',
      'resetFileBrowser',
    ]),
    async loadPage(page) {
      await this.loadAllFilesFromServer(page);
      this.setPage(page);
      if (!_.has(this.allBrowsedFiles, page)) {
        this.$set(this.allBrowsedFiles, page, this.serverFiles.data);
      }
    },
    onSearchFile() {
      this.searchFile(this.searchTerm);
    },
    isShowPagination() {
      return this.serverFiles.lastPage > 1;
    },
    showPaginate(n) {
      if ((n < this.limitPage && n >= this.page) || this.serverFiles.lastPage < 5) {
        return true;
      }
      return (this.serverFiles.lastPage - n) < 5 && (this.serverFiles.lastPage - this.page) < 5;
    },
    isActivePage(n) {
      if (!this.page) {
        return n === 1;
      }
      return this.page.toString() === n.toString();
    },
    onSelectFileOnServer(file, key) {
      const isAlreadySelected = _.find(this.selectedFiles, { id: file.id });

      if (!isAlreadySelected) {
        this.selectedFiles.push(file);
        _.remove(this.allBrowsedFiles[key], (serverFile) => serverFile.id === file.id);
      } else {
        this.allBrowsedFiles[1] = [file, ...this.allBrowsedFiles[1]];
        _.remove(this.selectedFiles, (selectedFile) => selectedFile.id === file.id);
      }
    },
    async attachSelectedFilesFromServer() {
      this.setActiveModal(null);
      await this.updateFilesToAttachment(this.selectedFiles);
      this.resetFileBrowser();
    },
    clearSearch() {
      this.loadAllFilesFromServer(1);
      this.searchTerm = '';
    },
  },
};
</script>

<style lang="scss" scoped>
@import './src/assets/scss/variables.scss';
@import './src/assets/scss/themes/components/modal-pagination.scss';

.hidden-input {
  display: none;
}
.choose-from-server-modal {
  .btn-close {
    z-index: 100;
    position: absolute;
    top: 16px;
    right: 10px;
    background: transparent;
    border: none;
    outline: none;
    transition: color 250ms ease;
    color: $gray-700;
    &:hover {
      color: $red;
    }
  }
  .choose-from-server-container {
    min-height: 600px;
    padding: 20px 20px 60px;
    position: relative;
    h5 {
      margin-bottom: 20px;
      button {
        border: none;
        background: transparent;
        i {
          color: $body-color;
        }
      }
    }
    .empty-small {
      min-height: 40vh;
    }
    input {
      margin-bottom: 10px;
    }
    .file-browser-container {
      .file-info {
        display: flex;
        flex-flow: row;
        padding: 10px 2px;
        cursor: pointer;
        transition: background 250ms ease;
        .circle-selector {
          display: flex;
          justify-content: center;
          align-items: center;
          width: 20px;
          .check {
            display: none;
          }
        }
        .info--icon {
          width: 50px;
          display: flex;
          justify-content: center;
          align-items: center;
          i {
            font-size: 42px;
          }
        }
        .info--meta {
          display: flex;
          justify-content: center;
          align-items: flex-start;
          flex-flow: column;
          flex: 1;
          h6 {
            font-weight: 600;
            margin: 0;
          }
          p {
            font-size: 10px;
            margin: 0;
          }
        }
        .info--actions {
          position: relative;
          display: flex;
          flex-flow: row;
          button {
            margin-right: 6px;
          }
        }
        &:hover {
          background: $gray-200;
        }
      }
      .file-info.checked {
        background: $gray-200;
        .check {
          display: block;
        }
        .uncheck {
          display: none;
        }
      }
      &.file-browser-selected-files {
        padding: 10px 0;
        border-bottom: 2px solid $gray-400;
        margin-bottom: 10px;
        max-height: 200px;
        overflow-y: auto;
        h5 {
          margin-bottom: 6px;
          font-size: 14px;
        }
      }
    }
    .file-browser-bottom {
      display: flex;
      justify-content: space-between;
      text-align: right;
      position: absolute;
      left: $spacer * 0.5;
      right: $spacer;
      bottom: 0;
      button {
        font-size: 12px;
        height: 38px;
      }
      .btn-delete {
        margin-right: 10px;
      }
      &.no-nav {
        left: 20px;
        right: unset;
        bottom: 10px;
      }
    }
  }
}
</style>
